// extracted by mini-css-extract-plugin
module.exports = {"root":"SessionModal_root__2q8gf","buttons":"SessionModal_buttons__14zmz","icon":"SessionModal_icon__KukBh"};